import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Logo from "./../assets/img/logo.png";
import "./../assets/sass/style.css";
import Sidedropdown from "./childComponents/dropDown";
import { API_SRC } from "./../commons/Constants";
import { IoIosArrowForward } from "react-icons/io";
import { FaCircle } from "react-icons/fa";

function Aside(props) {
  const navigate = useNavigate();
  const location = useLocation();

  const [isActivedupplicate, setIsActiveduplicate] = useState(null);
  const [isActivedabstract, setIsActiveabstract] = useState(false);
  const [isActivefulltext, setIsActivefulltext] = useState(false);
  const [sidebars, setSidebars] = useState(
    JSON.parse(localStorage.getItem("user"))
  );
  const currentPageId = JSON.parse(localStorage.getItem("pageId"));
  const menus = sidebars?.menu;

  const sideBarMenu = menus?.filter(
    (menu) => menu.module === "sideBar" && menu.parent_id === currentPageId
  );
  const sideTopMenu = menus?.filter((menu) => menu.module === "sideTop");
  const subMenusideBarMenu = menus?.filter(
    (menu) =>
      menu.parent_id === 1211 ||
      menu.parent_id === 1212 ||
      menu.parent_id === 1213
  );

  useEffect(() => {
  
    setSidebars(JSON.parse(localStorage.getItem("user")));
    // Update state based on current URL
    setIsActiveduplicate(null);
    setIsActiveabstract(false);
    setIsActivefulltext(false);
    localStorage.setItem("subPageId", currentPageId);
  }, [location.pathname, currentPageId]);

  const handleClickMenuDuplicate = (index) => {
    setIsActiveduplicate(isActivedupplicate === index ? null : index);
  };


  const handleClick = (event) => {
    const pageId = event.currentTarget.id;
    localStorage.setItem("subPageId", pageId);
    navigate("/" + pageId);
  };

  return (
    <div>
      <div className="aside-top-bar">
        <img src={Logo} alt="MISR Logo" className="img-fluid" />
      </div>
      <div className="aside">
        <div className="aside-div">
          <div className="d-flex aside__icon__bar">
            {sideTopMenu?.map((topRight, index) => (
              <NavLink to={"/dashboard"}>
                <img src={API_SRC + topRight.icon} alt="" />
              </NavLink>
            ))}
          </div>
        </div>
        <div className="sidebar__menu">
          <div id="myUL">
            {sideBarMenu
              ?.filter((sideBarLink) => sideBarLink.id !== 201 && sideBarLink.id !== 202)
              ?.sort((a, b) => (a.id === 205 ? -1 : b.id === 205 ? 1 : 0))
              ?.map((sideBarLink, index) =>
                sideBarLink.link === null ? (
                  <ul className="nav flex-column" id="nav_accordion" key={index}>
                    {sideBarLink.parent_id === 1201 ? (
                      <li className="nav-item has-submenu">
                        <span
                          className="nav-link bg--active--link"
                          onClick={() => handleClickMenuDuplicate(index)}
                        >
                          {sideBarLink.title}
                          <span
                            className={
                              isActivedupplicate === index
                                ? "right--menu--collapse test"
                                : "right--menu--collapse"
                            }
                          >
                            <IoIosArrowForward size={18} />
                          </span>
                        </span>
                        <ul
                          className={
                            isActivedupplicate === index
                              ? "submenu"
                              : "submenu collapse"
                          }
                        >
                          {subMenusideBarMenu
                            ?.filter((menu) => menu.parent_id === sideBarLink.id)
                            ?.map(({ title, id, link }, index) => (
                              <li
                                key={index}
                                className={
                                  "/" + link === location.pathname
                                    ? "li active"
                                    : "li"
                                }
                              >
                                <NavLink
                                  className={
                                    "/" + link === location.pathname
                                      ? "active nav-link inner--nav--link"
                                      : "nav-link inner--nav--link"
                                  }
                                  to={"/" + link}
                                >
                                  <span className="menu--link--for--count">
                                    <span className="ms-2 ">
                                      <FaCircle size={6} />
                                    </span>
                                    <span className="ms-2">
                                      {title === "Maybe" ? "Undecided" : title}
                                    </span>
                                    {id === "1241" ? (
                                      <span className="countCircle">
                                        {props.countTotal}
                                      </span>
                                    ) : id === "1242" ? (
                                      <span className="countCircle">
                                        {props.countIncluded}
                                      </span>
                                    ) : id === "1243" ? (
                                      <span className="countCircle">
                                        {props.countExcluded}
                                      </span>
                                    ) : (
                                      <span></span>
                                    )}
                                  </span>
                                </NavLink>
                              </li>
                            ))}
                        </ul>
                      </li>
                    ) : (
                      ""
                    )}
                  </ul>
                ) : (
                  <NavLink
                    onClick={handleClick}
                    to={"/" + sideBarLink.link}
                    key={index}
                    id={sideBarLink.id}
                    className={({ isActive }) => (isActive ? "li active" : "li")}
                  >
                    <li className="bg--active--link">{sideBarLink.title}</li>
                  </NavLink>
                )
              )}


          </div>
        </div>
        <Sidedropdown invitataionCount={props.invitaions} />
      </div>
    </div>
  );
}

export default Aside;
